import {Button, Card, CardBody, CardFooter, CardHeader, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {bankPayment, getBankPaymentResult} from "../services/payment/payment";
import {useNavigate} from "react-router-dom";
import persianNumberFormat from "../helper/PersianNumberFormat";
import {BsCheck, BsX} from "react-icons/bs";
import {redirectToPaymentLink} from "../helper/paymentGateway";

const PaymentResult = () => {
  const backgroundPhoto = '/assets/payment_background.jpg'

  const navigate = useNavigate();

  const [data, setData] = useState({})
  const [referenceCode, setReferenceCode] = useState(null)
  const [referenceId, setReferenceId] = useState(null)
  const [amount, setAmount] = useState(null)
  const [status, setStatus] = useState(null)
  const [description, setDescription] = useState(null)


  useEffect(() => {
    let id;
    const url = window.location.search;
    let params = new URLSearchParams(url);
    if (params.has('id')) {
      id = params.get('id');
    }

    async function getData(id) {
      const result = await getBankPaymentResult(id);
      if (result.status === 200) {
        const {transaction_info} = result.data;
        setData(transaction_info)
        localStorage.removeItem("transaction_id")
      }
    }

    getData(id)
  }, []);

  useEffect(() => {
    setReferenceCode(data.reference_code)
    setReferenceId(data.reference_id)
    setAmount(data.amount)
    setStatus(data.status)
    setDescription(data.description)
  }, [data]);


  const bank_payment = async () => {
    const payload = {
      amount: parseInt(data.amount),
      description: "wallet"
    };

    let result;
    result = await bankPayment(payload)
    if (result.status === 200) {
      const {id} = result.data;
      localStorage.setItem("transaction_id", id)
      redirectToPaymentLink(result.data);
    }
  };

  return (
    <div
      className={"flex justify-center items-center h-screen"}
      style={{backgroundImage: `url(${backgroundPhoto})`}}
    >
      <div className="absolute inset-0 bg-black opacity-50 "></div>
      <Card className="flex w-full mx-4 md:w-2/3">
        <CardHeader variant="gradient" color="gray" className="mb-4 pt-4 grid place-items-center">
          <Typography variant="h3" color="white" className="pt-4 mb-4">
            نتیجه تراکنش
          </Typography>
        </CardHeader>
        <CardBody className="flex flex-col gap-4 py-8 px-4 place-items-center">
          {status === "success" &&
            <>
              <div className="w-[6rem] h-[6rem] items-center rounded-full bg-green-200">
                <BsCheck className="w-full h-full text-green-700" size="lg" fontSize="lg"/>
              </div>
              <Typography variant="h5">
                کیف پول شما
                <span className="text-green-700">
                  {" " + persianNumberFormat(amount, true) + " ریال"}
                </span>
                شارژ شد
              </Typography>
              <Typography>
                کد رهگیری:
                <span>
                {persianNumberFormat(referenceId)}
              </span>
              </Typography>
            </>
          }
          {status !== "success" &&
            <>
              <div className="w-[6rem] h-[6rem] items-center rounded-full bg-red-200">
                <BsX className="w-full h-full text-red-700" size="lg" fontSize="lg"/>
              </div>
              <Typography variant="h5">
                افزایش اعتبار ناموفق بود.
              </Typography>
              <Typography>
                در صورت برداشت وجه از حساب بانکی شما مبلغ برداشت شده تا
                <span>
                  {" " + persianNumberFormat(48)}
                </span>
              </Typography>
              <Typography>
                ساعت آینده به حساب شما عودت داده می شود.
              </Typography>
            </>
          }
        </ CardBody>
        <CardFooter className="w-full text-center mt-4 space-x-2">

          <Button className="ml-4" color="gray" variant={status === "success" ? "gradient" : "text"} onClick={() => {
            const data = {redirect_component: description};
            localStorage.setItem("redirect_component", description);
            localStorage.setItem("status", status);
            navigate('/');
          }}>
            بازگشت به سایت
          </Button>
          {status !== "success" &&
            <Button className="mr-4" color="gray" variant="gradient" onClick={bank_payment}>
              تلاش مجدد
            </Button>
          }
        </CardFooter>
      </Card>
    </div>
  );
};

export default PaymentResult;
